import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable,  } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { GuidanceNote } from '@app/shared/models/guidanceNote';
import { LocalStorageService } from './local-storage-service';
@Injectable({
  providedIn: 'root'
})

export class GuidanceNotesService {

  constructor(
    private http: HttpClient,
    private _localStorageService: LocalStorageService
  ) { }

  private getDepartmentFromLocalStorage(): string {
    return this._localStorageService.getItem('selectedDepartment');
  }

  addGuidanceNote(guidanceNote: GuidanceNote): Observable<any> {
    const department = this.getDepartmentFromLocalStorage();

    const url = `${environment.api}/api/v1/department/${department}/guidancenotes?questionnaireId=${guidanceNote.questionnaireId}&questionId=${guidanceNote.questionId}`;

    return this.http.post(url, guidanceNote.text);
  }

  getGuidanceNote(questionId: string, questionnaireId: string): Observable<GuidanceNote[]> {
    const department = this.getDepartmentFromLocalStorage();

    const url = `${environment.api}/api/v1/department/${department}/guidancenotes?questionnaireId=${questionnaireId}&questionId=${questionId}`;

    return this.http.get<GuidanceNote[]>(url).pipe(
      map((response: any) => {
        return response.map((item: any) => ({
          id: item.id,
          questionId: item.questionId,
          questionnaireId: item.questionnaireId,
          title: item.title,
          text: item.text,
        })) as GuidanceNote[]
      })
    );
  }

  getSession(sessionID: string): Observable<any> {
    const department = this.getDepartmentFromLocalStorage();

    const url = `${environment.api}/api/v1/clientviewersession/${encodeURIComponent(sessionID)}/check?department=${encodeURIComponent(department)}`;

    return this.http.get(url);
  }

  addSessionToCache(sessionID: string, text: string): Observable<any> {
    const department = this.getDepartmentFromLocalStorage();

    const url = `${environment.api}/api/v1/clientviewersession/Add?id=${encodeURIComponent(sessionID)}&department=${encodeURIComponent(department)}`;
    const body = text;

    return this.http.post(url, body);
  }
}

